/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIBOM
 */
export interface APIBOM {
    /**
     * 
     * @type {string}
     * @memberof APIBOM
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIBOM
     */
    rootAccount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIBOM
     */
    parent: string;
    /**
     * 
     * @type {string}
     * @memberof APIBOM
     */
    child: string;
    /**
     * 
     * @type {Date}
     * @memberof APIBOM
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIBOM
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof APIBOM
     */
    amount?: number;
}

/**
 * Check if a given object implements the APIBOM interface.
 */
export function instanceOfAPIBOM(value: object): value is APIBOM {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('parent' in value) || value['parent'] === undefined) return false;
    if (!('child' in value) || value['child'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    return true;
}

export function APIBOMFromJSON(json: any): APIBOM {
    return APIBOMFromJSONTyped(json, false);
}

export function APIBOMFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBOM {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'rootAccount': json['root_account'] == null ? undefined : json['root_account'],
        'parent': json['parent'],
        'child': json['child'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function APIBOMToJSON(value?: Omit<APIBOM, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'root_account': value['rootAccount'],
        'parent': value['parent'],
        'child': value['child'],
        'amount': value['amount'],
    };
}

